import React from 'react';
import { MAX_SESSIONS_CAP } from '../../../utils/proSessionPricing';
import { MUTED } from '../../club/clubUi';
import { DashedButton, RoundX, pillInput } from '../setup/setupUi';

/**
 * A bookable service's multi-session settings: how many a client can book up front, and the deal
 * each count earns ("4 sessions, 5% off"). The discount comes out of the pro's own price.
 */
export default function SessionDealsEditor({ item, onChange }) {
  const max = item.maxSessions || 0;
  const on = max >= 2;
  const deals = item.sessionDiscounts || [];
  const input = (extra) => pillInput(36, { fontSize: 12, width: 64, flex: '0 0 64px', ...extra });
  const clampInt = (v, lo, hi) => Math.min(hi, Math.max(lo, Math.round(Number(v) || lo)));
  const setDeal = (i, patch) => onChange({ sessionDiscounts: deals.map((d, k) => (k === i ? { ...d, ...patch } : d)) });
  const addDeal = () => {
    const taken = deals.map((d) => d.sessions);
    const next = Array.from({ length: max - 1 }, (_, i) => i + 2).find((n) => !taken.includes(n));
    if (next) onChange({ sessionDiscounts: [...deals, { sessions: next, percentOff: next }] });
  };
  return (
    <div className="flex flex-col font-mono" style={{ gap: 8, padding: '10px 12px', borderRadius: 16, background: '#fff' }} data-testid="session-deals">
      <label className="flex items-center" style={{ gap: 10, fontSize: 10, fontWeight: 700, letterSpacing: '.12em' }}>
        <input type="checkbox" checked={on} aria-label="Book several sessions up front" onChange={(e) => onChange(e.target.checked ? { maxSessions: 4 } : { maxSessions: null, sessionDiscounts: [] })} />
        BOOK SEVERAL SESSIONS UP FRONT
      </label>
      {on && (
        <>
          <span className="flex items-center" style={{ gap: 8, fontSize: 11 }}>
            UP TO
            <input type="number" min="2" max={MAX_SESSIONS_CAP} value={max} aria-label="Most sessions at once" className="pr-pill-input font-mono" style={input()}
              onChange={(e) => { const m = clampInt(e.target.value, 2, MAX_SESSIONS_CAP); onChange({ maxSessions: m, sessionDiscounts: deals.filter((d) => d.sessions <= m) }); }} />
            SESSIONS
          </span>
          {deals.map((d, i) => (
            <span key={d.sessions} className="flex items-center" style={{ gap: 8, fontSize: 11 }} data-testid="session-deal">
              <input type="number" min="2" max={max} value={d.sessions} aria-label="Sessions for this deal" className="pr-pill-input font-mono" style={input()}
                onChange={(e) => { const n = clampInt(e.target.value, 2, max); if (!deals.some((x, k) => k !== i && x.sessions === n)) setDeal(i, { sessions: n }); }} />
              SESSIONS GET
              <input type="number" min="1" max="90" value={d.percentOff} aria-label="Percent off" className="pr-pill-input font-mono" style={input()}
                onChange={(e) => setDeal(i, { percentOff: clampInt(e.target.value, 1, 90) })} />
              % OFF
              <RoundX aria-label="Remove deal" onClick={() => onChange({ sessionDiscounts: deals.filter((_, k) => k !== i) })} />
            </span>
          ))}
          {deals.length < max - 1 && <DashedButton h={34} style={{ fontSize: 9 }} onClick={addDeal}>+ ADD A DEAL</DashedButton>}
          <span style={{ fontSize: 10, lineHeight: 1.5, color: MUTED }}>The discount comes off your price. You&apos;re paid session by session, as each one is done.</span>
        </>
      )}
    </div>
  );
}
